import { centerOfMass as turfCenter, polygon as turfPolygon } from "@turf/turf";

export const populationPolygons = (data, maxPopulation, minPopulation) => {
	let polygons = {},
		labels = {};
	const COLORS = ["#ff8b94", "#e6beff", "#CCC795", "#46f0f0", "#44885D", "#FF0000", "#FF7700", "#ffe119", "#00AAFF", "#00FF00"];
	const steps = maxPopulation / COLORS.length;

	for (let id in data) {
		let { polygon_name, coordinates, population } = data[id];
		let fillColor = "#FFFFFF11";

		for (let a = 0; a < COLORS.length; a++) {
			if (population <= steps * (a + 1)) {
				fillColor = COLORS[a] + "80";
				break;
			}
		}
		let centerofpolygon = findPolygons(coordinates);
		labels[`label_${id}`] = {
			position: centerofpolygon,

			data: {
				title: {
					text: polygon_name,
					color: "black", // This will not affect the label, as color customization is limited
					fontWeight: "bold", // This is not directly supported here
				},
			},
			showInfo: false,
			icon: { url: "#" },
		};
		polygons[id] = {
			id,
			coordinates,

			style: {
				fillColor: "#FFFFFF11",
				strokeColor: "#000000",
				strokeWeight: 2,
			},
			data: { polygon_name, population },
			showInfo: false,
		};
	}
	let legends = makeLegends(0, maxPopulation, COLORS);
	return { polygons, legends, labels };
};

export const populationDensityPolygons = (populationDensity) => {
	try {
		let polygons = {};
		for (let [ind, obj] of populationDensity.entries()) {
			let mLoc = {};
			ind = `density_${ind}`;
			mLoc.id = ind;
			let { population } = obj;

			mLoc.coordinates = obj.coordinates;
			mLoc.data = { population, weight: population };
			mLoc.marker = { position: obj.coordinates[0] };
			mLoc.showInfo = false;
			mLoc.style = {
				fillColor: "#FFFFFF11",
				strokeColor: "#00000000",
				zIndex: 11,
				strokeWeight: 3,
			};

			polygons[ind] = mLoc;
		}
		return polygons;
	} catch (err) {
		throw err;
	}
};

const findPolygons = (polygon = []) => {
	let turfpolygon = turfPolygon([polygon.map(({ lat, lng }) => [lng, lat])]);

	let center = turfCenter(turfpolygon);
	let {
		geometry: { coordinates },
	} = center;
	return { lat: coordinates[1], lng: coordinates[0] };
};

const makeLegends = (min, max, color) => {
	const increment = (max - min) / color.length;
	let legend = [];
	for (let i = 0; i < color.length; i++) {
		legend.push({
			text: `${(min + increment * i).toLocaleString(undefined, { maximumFractionDigits: 3 })}-${(
				min +
				increment * (i + 1)
			).toLocaleString(undefined, { maximumFractionDigits: 3 })}`,
			color: color[i],
		});
	}
	return legend;
};
